import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetailResponseDto } from 'shared/api';
import { InitialUserStateType } from './types';
import { userInit, createUser, getUserById } from './actions';

const initialState: InitialUserStateType = {
  user: null,
  authorizationStatus: null,
  isLoading: false,
  roles: [],
};

export const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    // TODO: сделать нормальное получение информации
    // builder.addCase(userInit.fulfilled, (state: InitialUserStateType, action: PayloadAction<UserDetailResponseDto>) => {
    builder.addCase(userInit.fulfilled, (state: InitialUserStateType, action: PayloadAction<InitialUserStateType>) => {
      state.user = action.payload.user;
      state.authorizationStatus = action.payload.authorizationStatus;
      state.roles = action.payload.roles || [];
    });

    // Без этого обработчика упавшая инициализация оставляет authorizationStatus === null,
    // RequireAuth в этом случае рендерит null - получается белый экран без единой подсказки.
    builder.addCase(userInit.rejected, (
      state: InitialUserStateType,
      action: PayloadAction<InitialUserStateType | undefined>,
    ) => {
      state.user = action.payload?.user || null;
      state.authorizationStatus = action.payload?.authorizationStatus
        || UserDetailResponseDto.status.SUSPENDED;
      state.roles = action.payload?.roles || [];
    });

    // Обработка создания пользователя
    builder.addCase(createUser.pending, (state: InitialUserStateType) => {
      state.isLoading = true;
    });
    builder.addCase(createUser.fulfilled, (state: InitialUserStateType, action: PayloadAction<UserDetailResponseDto>) => {
      state.user = action.payload;
      state.authorizationStatus = action.payload.status || UserDetailResponseDto.status.ACTIVE;
      state.isLoading = false;
    });
    builder.addCase(createUser.rejected, (state: InitialUserStateType) => {
      state.isLoading = false;
    });

    builder.addCase(getUserById.pending, (state: InitialUserStateType) => {
      state.isLoading = true;
    });
    builder.addCase(getUserById.fulfilled, (state: InitialUserStateType, action: PayloadAction<UserDetailResponseDto>) => {
      state.user = action.payload;
      state.isLoading = false;
    });
  },
});
